import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import renderIf from '../../../pkgs/render_if';
import MultiSelect from "@khanacademy/react-multi-select";
//import AsyncSelect from 'react-select/lib/Async';
import PropTypes from 'prop-types';

import {
  FormControl,
  HelpBlock,
} from 'react-bootstrap';

// const options = [
//   {label: "One", value: 1},
//   {label: "Two", value: 2},
//   {label: "Three", value: 3},
// ];

export default class ReactMultiSelect extends React.Component {

    constructor(props){
      super(props);
      this.state = {
        inputValue:[],
        options:[],
        options_loading: true,
        selected: [],
      };
    }

    componentDidMount = () => {
      let selected = this.props.editingInstance[this.props.field_id]
      // console.log('componentdidmount selected');
      // console.log(selected)
      // console.log('field_id');
      // console.log(this.props.field_id)
      if (selected != undefined) {
          this.setState({selected})
      }
      this.loadAwesompleteAJAXJSONResponse();
    }

    componentWillReceiveProps = (nextProps) => {
        let selected = nextProps.editingInstance[nextProps.field_id]

    }

    loadAwesompleteAJAXJSONResponse = () => {
      let app_label = this.props.app_label;
      let model_name = this.props.model_name;
      $.ajax({
          url: '/api/awesomplete/' + app_label + '/' + model_name + '/',
          dataType: 'json',
          cache: false,
          headers: {'Authorization': 'Token ' + localStorage.token},
          success: (data) => {
              this.setState({options:data})
          }
      });
    }

    onReplace = (selected) => {
        // console.log('selected:');
        // console.log(selected);
        if (this.timerid) {
          clearTimeout(this.timerid);
        }
        this.timerid = setTimeout(() => {
          this.props.onSelectChange(this.props.field_id, selected)
        }, 1);
        this.setState({selected});
    }


    render() {
        // console.log('React Multi-Select render()')
        const {selected} = this.state;
        return (
            <div style={{fontSize:'18px'}}>
                <MultiSelect
                    options={this.state.options}
                    selected={selected}
                    onSelectedChanged={selected => this.onReplace(selected)}
                />
            </div>
        );
    }
}

ReactMultiSelect.propTypes = {
    editingInstance: PropTypes.node,
    field_id: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/helpers/field/react_multi_select.js